import Box from '@mui/material/Box'
import { H3, P } from '@mxenabled/mxui'

import { ListProps, SectionTitleProps, TextProps } from '../../../core/types/Help'

export const Text: React.FC<TextProps> = ({ content, sx }) => (
  <P sx={{ lineHeight: '24px', py: 6, ...sx }}>{content}</P>
)

export const SectionTitle: React.FC<SectionTitleProps> = ({ content, sx }) => (
  <H3 color="text.primary" sx={{ py: 12, whiteSpace: { sm: 'nowrap' }, ...sx }}>
    {content}
  </H3>
)

export const List: React.FC<ListProps> = ({
  items,
  listType = 'ul',
  subItemPlacement,
  subItems = [],
  subListType = 'ol',
}) => {
  const Element = listType
  const SubElement = subListType

  return (
    <Box sx={{ [listType]: { m: 0, p: 0, pl: 16, '& li::marker': { fontSize: 15 } } }}>
      <Element>
        {items.map((elm, i) => (
          <li key={i}>
            <Text content={elm} sx={{ py: 1 }} />
            {subItemPlacement === i ? (
              <SubElement {...(subListType === 'ol' && { type: 'a' })}>
                {subItems.map((subElm, index) => (
                  <li key={index}>
                    <Text content={subElm} sx={{ py: 1 }} />
                  </li>
                ))}
              </SubElement>
            ) : null}
          </li>
        ))}
      </Element>
    </Box>
  )
}
